export enum TenancyContactAction {
	NEW_CONTRACT = "new_contract",
	RENEW_CONTRACT = "renew_contract",
	TERMINATE_CONTRACT = "terminate_contract",
	UPDATE_CONTRACT = "update_contract",
}

function notImplemented<X>() {
	throw "Not implemented";
	return undefined as any as X;
}

interface IEjariHooks {
	getParticipantID: () => number | undefined;
	getEjariUserType: () => number;
	getEjariActiveUserId: () => number;
	isOwnerLoggedIn: () => boolean;
	getMobileNumber: () => string | undefined;
	getEmiratesId: () => string | undefined;
}

export const EjariCoreConfig: IEjariHooks = {
	getParticipantID: () => notImplemented<number>(),
	getEjariUserType: () => notImplemented<number>(),
	getEjariActiveUserId: () => notImplemented<number>(),
	isOwnerLoggedIn: () => notImplemented<boolean>(),
	getMobileNumber: () => notImplemented<string>(),
	getEmiratesId: () => notImplemented<string>(),
};

export enum TenantDocumentType {
	TERMINATE = 41,
	PERSON = 39,
}

export enum TenantRequestAction {
	NEW = 1,
	RENEW = 2,
	TERMINATE = 4,
}

export enum TenantRequestStatus {
	ACTIVE = 1,
	PENDING = 2,
	TERMINATE = 3,
	PAYMENT_PENDING = 4,
	REQUEST_FOR_UPDATE = 5,
	CANCEL = 6,
	REJECTED = 7,
	SUBMIT = 8,
}

export enum TenantRequestUserType {
	OWNER = 4,
	TENANT = 12,
}
